import React from 'react';

export const NotFound = () => {
  return (
    <main className="container mx-auto px-4 py-8 mb-auto relative">
      <h2>404 - Not Found</h2>
      <p>The page you are looking for does not exist.</p>
    </main>
  );
};